/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_FailedInputs */

const vi_einvoice_publish_failed = /** @type {(inputs: Einvoice_Publish_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa phát hành được hóa đơn. Hãy tải lại bản nháp và kiểm tra trạng thái trước khi thử lại.`)
};

/**

* @param {Einvoice_Publish_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_failed = /** @type {((inputs?: Einvoice_Publish_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_failed(inputs)
});